import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import Loader from '../../Loader/Loader';

import { api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../Utils';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import Swal from 'sweetalert2'

import { language } from './Language';
import { icon } from '../../WEBContent/Icon';

export default function List() {
	const [, set_dados] = useState(null);
	const permissions = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');
    const [max_order, set_max_order] = useState(0);

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    // const [permissions, set_permissions] = useState({})

    const [, setRefresh] = useState(0)

    const handleRowClick = (id) => {
        document.getElementById('c_' + id)?.click();
    };

    const get_info = async () => {
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                // console.log('res.data', res.data)
                setData(res.data)
            })
            .catch(() => 404
            )

        await reqGET(api_list_order(getTokenInfo().companycode))
            .then(res => {
                // console.log('res.data 2', res.data)
                if (res.data[0]['max'] !== null)
                    set_max_order(res.data[0]['max'])
                //setLoading(false)
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name && subitem.allow) {

                            let aux = {}
                            if(permissions.current !== null) {
                                aux = permissions.current

                                if(aux.create === false) {
                                    aux.create = subitem.create
                                }
                                if(aux.edit === false) {
                                    aux.edit = subitem.edit
                                }
                                if(aux.remove === false) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            setRefresh(r => r + 1)
                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name && node.allow && 0) {

                    let aux = {}
                    if(permissions.current !== null) {
                        aux = permissions.current

                        if(aux.create === false) {
                            aux.create = node.create
                        }
                        if(aux.edit === false) {
                            aux.edit = node.edit
                        }
                        if(aux.remove === false) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    setRefresh(r => r + 1)
                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)
                } else
                    await ver_submenu(node)
            }
        }

        handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if(getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }
                
            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const columns = [
        {
            name: language[lang].name,
            selector: 'info.name',
            width: '40% !important',
            minWidth: '200px !important',
            sortable: true,
            let: true,
        },
        { //localização dos departamentos
            name: language[lang].local,
            width: '30% !important',
            minWidth: '110px !important',
            selector: "info.localidade",
            cell: row => (
                row.info.localidade ?
                    <span>
                        <div> {row.info.localidade} </div>
                    </span>
                    :
                    <span className="badge rounded-0 bg-danger">
                        <i className="bi bi-x-lg text-white fs-4"></i>
                    </span>
            ),
        },
        { //estado
            name: language[lang].table_state,
            selector: 'info.state',
            width: '15% !important',
            minWidth: '150px !important',
            cell: row => (
                row.info.state ?
                    <span className="badge rounded bg-success badge-sm ">
                        <i className="bi bi-check-lg text-white fs-4 icon-lista-departamentos"></i>
                    </span>
                    :
                    <span className="badge rounded bg-danger badge-sm " >
                        <i className="bi bi-x-lg text-white fs-4 icon-lista-departamentos "></i>
                    </span>
            ),
            sortable: true,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '15% !important',
            minWidth: '150px !important',
            cell: row =>
                <span onClick={() => handleRowClick(row.id)} style={{ cursor: 'pointer' }}>
                    {/* Hidden Link for View */}
                    <Link
                        id={'c_' + row.id}
                        className="button button-update button-view d-none"
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        replace
                    >
                        <i className={icon.view.className} style={icon.view.style}></i>
                    </Link>

                    {/* Permissions for Edit */}
                    {permissions.current !== null && (permissions.current.edit) /* && (getTokenInfo().profile === 'Administrador' || getTokenInfo().profile === 'TeamLeader') */ ? (
                        <Link
                            className={permissions.current.edit ? "button button-update" : "d-none"}
                            to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                            replace
                            onClick={(e) => e.stopPropagation()}
                        >
                            <i className={icon.pencil.className} style={icon.pencil.style}></i>
                        </Link>
                    ) : null}

                    {/* Permissions for Delete */}
                    {permissions.current !== null && permissions.current.remove /* && (getTokenInfo().profile === 'Administrador') && */ ? (
                        <button
                            className="button button-delete"
                            onClick={(e) => {
                                e.stopPropagation();
                                apagar(row['id']);
                            }}
                            aria-label="Delete Ticket"
                        >
                            <i className={icon.trash.className} style={icon.trash.style}></i>
                        </button>
                    )
                    :
                        null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main id="lista-departamentos">
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].category_list}</h2>
                <p>{language[lang].category_list}</p>
            </div>

            <div className={`dash-cards body`} >
                <div className="container container-icons" >
                    <div className="row" >
                        <div className="card mb-5 mb-xl-8">
                            <div className="card-body">
                                <div className="pb-10">
                                    <div className="div-table" >
                                        {(permissions.current !== null && permissions.current.create) && (
                                             <div className="table-header text-end mb-8">
                                                <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                    to={{ pathname: endpoints.regist }}
                                                    style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                                >
                                                    <span>{language[lang].add_new}</span>
                                                </Link>
                                            </div>
                                        )}
                                        <div className="table-body" >
                                            <DataTableExtensions {...tableData} >
                                                <DataTable
                                                    noDataComponent={language[lang].table_empty}
                                                    noHeader
                                                    pagination
                                                    exportHeaders
                                                    paginationComponentOptions={defaultComponentOptions}
                                                    paginationPerPage={25}
                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                    onRowClicked={(row) => handleRowClick(row.id)}
                                                    customStyles={{
                                                        rows: {
                                                            style: {
                                                                cursor: 'pointer',
                                                            },
                                                        },
                                                    }}
                                                />
                                            </DataTableExtensions>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}